import axios from 'axios';
import { APIOverrides } from "../../ApiOverrides";
import type { AthleteProps, EventProps, LeagueProps, MatchProps, TeamProps, TournamentProps } from '../../types';

let EVENT_SVC_API = ''
//let AUTH_SVC_API = ''

export { EventComponentApi }

const EventComponentApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        //MK_SVC_API = endpoints['MK_SVC_API'] as string;
        //AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
    },
    getTeamById: async(team_id:string):Promise<undefined|TeamProps> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/teams/team/${team_id}`);
            return resp.data.team
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    getLeagues: async():Promise<LeagueProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues?status=active`)
            return resp.data.leagues
        } catch (e) {
            return []
        }
    },
    getEventsByEventIds: async(event_ids:string[]):Promise<EventProps[]> => {
        try {
            if(event_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/events/bulk/get`, { attribute:'event_id', values: event_ids })
            return resp.data.events
        } catch (e) {
            return []
        }
    },
    getEventsByDate: async(league_id:string, date:string, timezone?:string):Promise<{day:string, days:string[], events:EventProps[]}> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/events/league/date/${league_id}/${date}?timezone=${timezone}`);
            return resp.data
        } catch (e) {
            return { day: date, days:[], events: [] }
        }
    },
    getMatchesByMatchIds: async(match_ids:string[]):Promise<MatchProps[]> => {
        try {
            if(match_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/matches/bulk/get`, { attribute: 'match_id', values: match_ids })
            return resp.data.matches
        } catch (e) {
            return []
        }

    },
    getAthletesByIds : async(athlete_ids:string[]):Promise<AthleteProps[]> => {
        try {
            if(athlete_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/athletes/bulk/get`, { attribute: 'athlete_id', values: athlete_ids })
            return resp.data.athletes
        } catch (e) {
            return []
        }
    },
    getTournamentsByTournamentIds: async(tournament_ids:string[]):Promise<TournamentProps[]> => {
        try {
            if(tournament_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/tournaments/bulk/get`, { attribute: 'event_id', values: tournament_ids })
            return resp.data.tournaments
        } catch (e) {
            return []
        }
    },
    getTeamsByIds: async(team_ids:string[]) => {
        try {
            if(team_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/teams/bulk/get`, { attribute:'team_id', values: team_ids })
            return resp.data.teams
        } catch (e) {
            return []
        }

    },
    getUpcomingScheduleByTeams: async(team_ids:string, offset:number):Promise<EventProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/teams/schedule/upcoming/${team_ids}?offset=${offset}`)
            return resp.data.events
        } catch (e) {
            return []
        }
    },
    getPastScheduleByTeams: async(team_ids:string, offset:number):Promise<EventProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/teams/schedule/past/${team_ids}?offset=${offset}`)
            return resp.data.events
        } catch (e) {
            return []
        }
    }
}